<zimmerer-route-ion-wrapper class="ion-page">
  <div class="threecol">
    <div class="main-col noSlider">
      <!-- breadcrumb -->
      <div>
        <span (click)="StateService.goto('/blog')" style="text-decoration: underline; cursor: pointer">Blog</span>
        > Beitrag {{ edit ? 'bearbeiten' : 'erstellen' }}
      </div>

      <div class="stepper-container">
        <form [formGroup]="form" *ngIf="form && userService.user">
          <mat-horizontal-stepper linear #stepper class="createStepper">
            <div class="mat-horizontal-stepper-container">
              <mat-step
                label="step 1"
                [completed]="stepsCompleted > 0"
                *ngIf="shouldShowProfileSelect"
                class="stepper-flex"
                style="display: flex"
              >
                <div class="step-selector-container-wrapper">
                  <div class="step-selector-container">
                    <ng-template matStepLabel> Profil wählen </ng-template>

                    <div class="step-selector-top-container">
                      <div class="step-selector-top">
                        <div class="title">
                          {{ 'Erstelle jetzt deinen Blog-Beitrag' }}
                        </div>
                        <div class="subtitle">
                          {{ 'Informiere Deine Kollegen und begeistere zusammen mit uns für den Holzbau!' }}
                        </div>
                      </div>
                    </div>

                    <div class="step-selector-middle-container">
                      <div class="step-selector-middle">
                        <!-- create as -->
                        <div class="fat1">Profil</div>
                        <div>
                          <profile-selector [form]="form"> </profile-selector>
                        </div>
                      </div>
                    </div>

                    <app-credits-warning
                      *ngIf="userService.hasCompanyProfile()"
                      [is_edit]="draft.is_edit"
                      [profile_type]="form.get('profile_type').value"
                      [entity_type]="'BLOG'"
                      [company_profile]="userService.getCompanyProfile()"
                    >
                    </app-credits-warning>

                    <div class="step-selector-bottom-container">
                      <button (click)="nextIfFormValid(false, ['profile_type'])" class="orange-button">Weiter</button>
                    </div>
                  </div>
                </div>
              </mat-step>

              <mat-step label="step 2" [completed]="stepsCompleted > 1" class="stepper-flex">
                <div class="step-selector-container-wrapper">
                  <div class="step-selector-container">
                    <div class="step-selector-top-container">
                      <div class="step-selector-top">
                        <ng-template matStepLabel> Kategorie wählen </ng-template>

                        <div class="title">
                          {{ 'Kategorie wählen' }}
                        </div>
                        <div class="subtitle">
                          {{
                            Mobileservice.isMobile
                              ? 'Hier kannst Du einen Blog-Beitrag ' + (edit ? 'bearbeiten' : 'erstellen') + '.'
                              : 'Unter welcher Kategorie willst du deinen Blog-Beitrag veröffentlichen?'
                          }}
                        </div>
                      </div>
                    </div>

                    <div class="step-selector-middle-container">
                      <!-- Category -->

                      <mat-form-field>
                        <app-category-selection
                          [isSideBar]="false"
                          formControlName="category"
                          [inputCategories]="{ type: CategoryType.blog }"
                        >
                        </app-category-selection>
                      </mat-form-field>

                      <mat-error
                        *ngIf="
                          (formSubmitted || form.get('category').touched) && form.get('category').hasError('required')
                        "
                      >
                        *Bitte wähle eine Kategorie aus
                      </mat-error>
                    </div>

                    <app-credits-warning
                      *ngIf="userService.hasCompanyProfile()"
                      [is_edit]="draft.is_edit"
                      [profile_type]="form.get('profile_type').value"
                      [entity_type]="'BLOG'"
                      [company_profile]="userService.getCompanyProfile()"
                    >
                    </app-credits-warning>

                    <div class="step-selector-bottom-container">
                      <button (click)="nextIfFormValid(false, ['profile_type', 'category'])" class="orange-button">
                        Weiter
                      </button>
                    </div>
                  </div>
                </div>
              </mat-step>

              <!-- details -->
              <mat-step label="step 3" [completed]="stepsCompleted > 2">
                <ng-template matStepLabel> Details angeben </ng-template>

                <div fxLayout="column" fxLayoutGap="20px">
                  <div fxHide.gt-md class="title">Details angeben</div>

                  <!-- title -->
                  <div fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutGap.lt-lg="0px">
                    <div fxFlex="20" fxLayout="row" fxLayoutAlign="start center" class="fieldHeadline">
                      Titel des Beitrags
                    </div>

                    <div class="full-width-input">
                      <mat-form-field>
                        <input
                          matInput
                          placeholder="Titel"
                          type="text"
                          formControlName="title"
                          (blur)="updateDraft()"
                        />

                        <div>
                          <mat-error
                            *ngIf="
                              (formSubmitted || form.get('title').touched) && form.get('title').hasError('required')
                            "
                          >
                            *Titel ist ein Pflichtfeld
                          </mat-error>
                          <mat-error
                            *ngIf="
                              (formSubmitted || form.get('title').touched) && form.get('title').hasError('minlength')
                            "
                          >
                            *Titel muss min. 3 Zeichen lang sein
                          </mat-error>
                          <mat-error
                            *ngIf="
                              (formSubmitted || form.get('title').touched) && form.get('title').hasError('maxlength')
                            "
                          >
                            *Titel darf max. 254 Zeichen lang sein
                          </mat-error>
                        </div>
                      </mat-form-field>
                    </div>
                  </div>

                  <!-- teaser text -->
                  <div fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutGap.lt-lg="0px">
                    <div fxFlex="20" fxLayout="row" fxLayoutAlign="start center" class="fieldHeadline">
                      Ankündigungstext
                    </div>

                    <div class="full-width-input">
                      <mat-form-field>
                        <textarea
                          style="
                            width: 100%;
                            min-height: 100px;
                            padding: 10px 10px;
                            text-indent: 0px;
                            box-sizing: border-box;
                          "
                          class="zimTextarea"
                          matInput
                          placeholder="Teaser Text"
                          formControlName="teaser"
                          (blur)="updateDraft()"
                          autoresize
                        >
                        </textarea>
                        <div>
                          <mat-error
                            *ngIf="
                              (formSubmitted || form.get('teaser').touched) && form.get('teaser').hasError('required')
                            "
                          >
                            *Teaser Text ist ein Pflichtfeld
                          </mat-error>
                          <mat-error
                            *ngIf="
                              (formSubmitted || form.get('teaser').touched) && form.get('teaser').hasError('minlength')
                            "
                          >
                            *Teaser Text muss min. 3 Zeichen lang sein
                          </mat-error>
                          <mat-error
                            *ngIf="
                              (formSubmitted || form.get('teaser').touched) && form.get('teaser').hasError('maxlength')
                            "
                          >
                            *Teaser Text darf max. 25000 Zeichen lang sein
                          </mat-error>
                        </div>
                      </mat-form-field>
                    </div>
                  </div>

                  <!-- video url -->
                  <div
                    *ngIf="isVideo"
                    fxLayout="row"
                    fxLayoutGap="20px"
                    fxLayout.lt-lg="column"
                    fxLayoutGap.lt-lg="0px"
                  >
                    <div fxFlex="20" fxLayout="row" fxLayoutAlign="start center" class="fieldHeadline">VideoURL</div>

                    <div class="full-width-input">
                      <mat-form-field>
                        <input
                          matInput
                          placeholder="Youtube oder Vimeo Link"
                          type="text"
                          formControlName="videourl"
                          (blur)="updateDraft()"
                        />
                        <div>
                          <mat-error
                            *ngIf="
                              (formSubmitted || form.get('videourl').touched) &&
                              (form.hasError('videourlRequired') || form.get('videourl').hasError('pattern'))
                            "
                          >
                            *Bitte gib eine gültige Youtube oder Vimeo URL an
                          </mat-error>
                          <mat-error
                            *ngIf="
                              (formSubmitted || form.get('videourl').touched) &&
                              form.get('videourl').hasError('domainNotAllowed')
                            "
                          >
                            *Es sind nur Youtube oder Vimeo Links erlaubt
                          </mat-error>
                        </div>
                      </mat-form-field>
                    </div>
                  </div>

                  <!-- main image -->
                  <div
                    *ngIf="!isVideo"
                    fxLayout="row"
                    fxLayoutGap="20px"
                    fxLayout.lt-lg="column"
                    fxLayoutGap.lt-lg="0px"
                  >
                    <mat-form-field style="display: none">
                      <app-image-formcontrol matInput formControlName="mainImage"></app-image-formcontrol>
                    </mat-form-field>

                    <div fxFlex="20" fxLayout="row" fxLayoutAlign="start center" class="fieldHeadline">Hauptbild</div>

                    <div style="padding: 0.4375em 0">
                      <div *ngIf="draft.mainImage" style="margin-bottom: 10px">
                        <edit-images
                          *ngIf="draft.mainImage && !draft.mainImage.isFallback"
                          [editImage]="editImage.bind(this)"
                          [images]="[draft.mainImage]"
                          [deleteImage]="deleteImage.bind(this)"
                          [key]="'MAIN,SLIDE'"
                        >
                        </edit-images>
                      </div>

                      <image-upload-box
                        *ngIf="!draft.mainImage || draft.mainImage.isFallback"
                        [fileSelected]="fileSelected.bind(this)"
                        [fileDropped]="fileDropped.bind(this)"
                        [key]="'MAIN,SLIDE'"
                        [multiple]="false"
                      >
                      </image-upload-box>
                    </div>
                  </div>

                  <!-- fallback image -->
                  <div
                    *ngIf="showFallbackImages()"
                    fxLayout="row"
                    fxLayoutGap="20px"
                    fxLayout.lt-lg="column"
                    fxLayoutGap.lt-lg="0px"
                  >
                    <div fxFlex="20" fxLayout="row" fxLayoutAlign="start center">
                      Falls Du kein passendes Bild findest, nutze unsere Bildergalerie:
                    </div>

                    <mat-form-field style="display: none">
                      <input matInput type="text" formControlName="fallbackImage" />
                    </mat-form-field>

                    <div>
                      <div fxLayout="row wrap" fxLayoutGap="20px">
                        <div *ngFor="let image of fallbackImages" style="cursor: pointer; position: relative">
                          <img
                            [src]="image.fullUrl.cached"
                            style="width: 70px; height: 70px"
                            (click)="setFallbackImage(image)"
                          />
                          <div
                            fxLayout="row"
                            fxLayoutAlign="center center"
                            class="fallbackImageSelected"
                            *ngIf="
                              draft.fallbackImage &&
                              draft.fallbackImage.fullUrl &&
                              draft.fallbackImage.fullUrl.cached == image.fullUrl.cached
                            "
                          >
                            <i class="fas fa-check" style="font-size: 35px; color: white"></i>
                          </div>
                        </div>
                      </div>
                      <div>
                        <mat-error *ngIf="formSubmitted && form.hasError('mainImageRequired')">
                          *Lade ein Hauptbild zum Beitrag hoch
                        </mat-error>
                      </div>
                    </div>
                  </div>

                  <!-- images -->
                  <div
                    *ngIf="!isVideo"
                    fxLayout="row"
                    fxLayoutGap="20px"
                    fxLayout.lt-lg="column"
                    fxLayoutGap.lt-lg="0px"
                  >
                    <div fxFlex="20" fxLayout="row" fxLayoutAlign="start center" class="fieldHeadline">Bilder</div>

                    <div style="padding: 0.4375em 0">
                      <div
                        id="img_list_1"
                        *ngIf="draft.images.length > 0"
                        class="image-list"
                        style="margin-bottom: 10px; display: flex; flex-wrap: wrap; gap: 10px"
                      >
                        <div
                          *ngFor="let image of draft.images"
                          [hidden]="image.image.purpose_key?.includes('MAIN')"
                          class="image-item dropbox"
                          (drop)="drop($event, image)"
                          (dragover)="allowDrop($event, image)"
                        >
                          <div class="dragbox" draggable="true" (dragstart)="drag($event, image)">
                            <edit-images
                              [images]="[image]"
                              [editImage]="editImage.bind(this)"
                              [deleteImage]="deleteImage.bind(this)"
                              [key]="'SLIDE'"
                            >
                            </edit-images>
                          </div>
                        </div>
                      </div>

                      <image-upload-box
                        [fileSelected]="fileSelected.bind(this)"
                        [fileDropped]="fileDropped.bind(this)"
                        [key]="'SLIDE'"
                      >
                      </image-upload-box>
                    </div>
                  </div>

                  <!-- content -->
                  <div fxLayout="row" fxLayoutGap="20px" fxLayout.lt-lg="column" fxLayoutGap.lt-lg="0px">
                    <div fxFlex="20" fxLayout="row" fxLayoutAlign="start center" class="fieldHeadline">
                      Beschreibungstext
                    </div>

                    <div fxFlex="grow" style="padding: 0.4375em 0">
                      <editor
                        apiKey="cirw0hv94c52sgyqp5rseuz1djp09a8nptls2c9a41ypi805"
                        [init]="tinyAutogrowConfig"
                        formControlName="content"
                        (onBlur)="updateDraft()"
                      ></editor>

                      <div>
                        <mat-error
                          *ngIf="
                            (formSubmitted || form.get('content').touched) && form.get('content').hasError('required')
                          "
                        >
                          *Beschreibungstext ist ein Pflichtfeld
                        </mat-error>
                        <mat-error
                          *ngIf="
                            (formSubmitted || form.get('content').touched) && form.get('content').hasError('minlength')
                          "
                        >
                          *Beschreibungstext muss min. 3 Zeichen lang sein
                        </mat-error>
                        <mat-error
                          *ngIf="
                            (formSubmitted || form.get('content').touched) && form.get('content').hasError('maxlength')
                          "
                        >
                          *Beschreibungstext darf max. 25000 Zeichen lang sein
                        </mat-error>
                      </div>
                    </div>
                  </div>

                  <!-- form errors -->
                  <div
                    *ngIf="formSubmitted && form.invalid"
                    fxLayout="row"
                    fxLayoutAlign="end"
                    class="form-validation-errors"
                  >
                    <div class="form-validation-error">Bitte prüfe deine Eingaben.</div>
                  </div>

                  <!-- <div>{{form.errors | json}}</div> -->

                  <app-credits-warning
                    *ngIf="userService.hasCompanyProfile()"
                    [is_edit]="draft.is_edit"
                    [profile_type]="form.get('profile_type').value"
                    [entity_type]="'BLOG'"
                    [company_profile]="userService.getCompanyProfile()"
                  >
                  </app-credits-warning>
                </div>

                <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="10px">
                  <button class="black-button" matStepperPrevious>Zurück</button>
                  <button class="orange-button" (click)="nextIfFormValid(false)">Weiter</button>
                </div>
              </mat-step>

              <!-- preview -->
              <mat-step label="preview" [completed]="stepsCompleted > 2">
                <ng-template matStepLabel> Vorschau </ng-template>

                <div fxHide.gt-md>Vorschau</div>
                <div fxLayout="column" fxLayoutGap="20px">
                  <app-blog-display *ngIf="currentStepLabel == 'preview'" [live]="false" [entity]="draft">
                  </app-blog-display>

                  <app-credits-warning
                    *ngIf="userService.hasCompanyProfile()"
                    [is_edit]="draft.is_edit"
                    [profile_type]="form.get('profile_type').value"
                    [entity_type]="'BLOG'"
                    [company_profile]="userService.getCompanyProfile()"
                  >
                  </app-credits-warning>

                  <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="10px">
                    <button matStepperPrevious>Zurück</button>
                    <button class="orange-button" (click)="publish()">Veröffentlichen</button>
                  </div>
                </div>
              </mat-step>

              <!-- success / share -->
              <mat-step label="last step" [completed]="stepsCompleted > 3">
                <ng-template matStepLabel>Geschafft!</ng-template>

                <div fxLayout="column" fxLayoutGap="20px" *ngIf="currentStepLabel == 'last step'">
                  <div>
                    <b>Geschafft!</b><br />
                    Dein Beitrag wird in Kürze online sein!
                  </div>

                  <div *ngIf="draft.accepted_by_admin">
                    <p>Beitrag teilen:</p>

                    <share-buttons
                      [include]="Mobileservice.isMobile ? appConfig.shareconfig_mobile : appConfig.shareconfig_desktop"
                      [show]="appConfig.sharebuttonsmax"
                      [showText]="true"
                      [url]="draft.getOpgraphData().url"
                      [autoSetMeta]="false"
                      description=" "
                    >
                    </share-buttons>
                  </div>

                  <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px" fxLayout.lt-lg="column">
                    <button class="dark-grey-button" (click)="goToCreate()">
                      <span fxHide.lt-lg>Weiteren Beitrag erstellen</span>
                      <span fxHide.gt-md>Weiteren Beitrag</span>
                    </button>
                    <button class="dark-grey-button" (click)="goBackToList()">
                      <span fxHide.lt-lg>Zurück zur Übersicht</span>
                      <span fxHide.gt-md>Zur Übersicht</span>
                    </button>
                  </div>
                </div>
              </mat-step>
            </div>
          </mat-horizontal-stepper>
        </form>
      </div>

      <app-blog-related-items
        [direction]="Mobileservice.isMobile ? 'vertical' : 'horizontal'"
        [items]="mostViewed"
        [title]="'Das könnte dich auch interessieren'"
        *ngIf="mostViewed && mostViewed.length > 0 && currentStepLabel == 'last step'"
      >
      </app-blog-related-items>
    </div>
  </div>
</zimmerer-route-ion-wrapper>
